import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import { useState } from "react";
import type { AccessPermission } from "@entrilia/shared/api/types";
import AuthorizedBox from "@entrilia/shared/components/AuthorizedBox";
import { useNotificationContext } from "@entrilia/shared/contexts/NotificationContext";
import usePageTitle from "@entrilia/shared/hooks/usePageTitle";
import useClientContext from "../../../../../context/useClientContext";
import GeneralPageHeader from "../../../../common/GeneralPageHeader";
import AddGroupDialog from "./actions/AddGroupDialog.tsx";
import GroupsGrid from "./GroupsGrid";
import type { GroupType } from "./GroupType";

interface Props {
  permissions: AccessPermission[];
  title: string;
  type: GroupType;
}

export const GroupsPage = ({ permissions, title, type }: Props) => {
  usePageTitle(title);

  const { clientCode } = useClientContext();
  const [showAddLevel, setShowAddLevel] = useState(false);
  const { sendNotification } = useNotificationContext();

  return (
    <Stack spacing={1} sx={{ height: "100%", width: "100%" }}>
      <GeneralPageHeader showDefaultBackButtonTo={".."} title={title}>
        <AuthorizedBox permissions={[...permissions]}>
          <Button variant="contained" onClick={() => setShowAddLevel(true)}>
            Add Group
          </Button>
        </AuthorizedBox>
      </GeneralPageHeader>
      <Stack
        spacing={0.5}
        useFlexGap
        sx={{
          flex: 1,
          px: 3,
          backgroundColor: "background.paper",
          width: "100%",
        }}
      >
        <Box sx={{ pt: 1, pl: 2 }}>
          <Typography variant="subtitle2">Name</Typography>
        </Box>
        <Grid container sx={{ flex: 1, width: "100%" }}>
          <GroupsGrid permissions={permissions} type={type} />
        </Grid>
        {showAddLevel && (
          <AddGroupDialog
            clientCode={clientCode}
            onAdded={() => sendNotification("The group was successfully created.")}
            onClose={() => setShowAddLevel(false)}
          />
        )}
      </Stack>
    </Stack>
  );
};

export default GroupsPage;
